import Vue from 'vue'
import Vuex from 'vuex'
import ApiService from '@/services/ApiService.js'
import createPersistedState from 'vuex-persistedstate'

Vue.use(Vuex)

const store = new Vuex.Store({
  strict: true,
  plugins: [createPersistedState()],
  state: {
    isLoading: false,
    isError: null,
    voucher: [],
    currentSelected: null
  },
  mutations: {
    SET_LOADING(state, status) {
      state.isLoading = status
    },
    SET_VOUCHERS(state, items) {
      state.voucher = items
    },
    SELECT_VOUCHER(state, key) {
      state.currentSelected = key
    },
    SET_ERROR(state, msg) {
      state.isError = msg
    }
  },
  actions: {
    async fetchVouchers(context) {
      context.commit('SET_LOADING', true)
      let response = await ApiService.getShop();
      context.commit('SET_LOADING', false)
      if (response.status == 200) {
        context.commit('SET_ERROR', null)
        context.commit('SET_VOUCHERS', response.data)
      } else {
        context.commit('SET_ERROR', (response.data.error) ? response.data.error : 'defaultError')
      }
    }
  },
  getters: {
    isLoading(state) {
      return state.isLoading
    },
    allVouchers(state) {
      return state.voucher
    },
    currentVoucher(state) {
      return (state.currentSelected === null) ? false : state.voucher.filter(v => v.id === state.currentSelected)[0]
    },
    errorMsg(state) {
      return (state.isError === null) ? false : state.isError
    }
  }
})

export default store
